import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';

function DonotCover({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
}) {
    const { t } = useTranslation();

    const methods = useForm();
    const [loader, setLoader] = useState(false);
    const { control, formState: { errors }, handleSubmit } = methods;

    useEffect(() => {

        methods.reset({ dnc_reason: '' })

    }, [isOpen])



    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => {
                    setLoader(true);
                    onConfirm(data, "dnc", ()=> setLoader(false))
                })}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">{t("donotCover.title")}</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1'>
                            <h2>{t("translation.appointmentId")}: {appointmentId}</h2>
                            <div className="row-primary">
                                <h2>{t("translation.reason")}</h2>
                                <div className='w-100'>
                                    {/* Reason */}
                                    <div className="row-primary w-100">
                                        <Controller
                                            name="dnc_reason"
                                            control={control}
                                            rules={{
                                                required: t("translation.pleaseWriteReason")
                                            }}
                                            render={({ field }) =>
                                                <>
                                                    <textarea
                                                        className="type_inp input-in"
                                                        {...field}
                                                        placeholder={t("donotCover.placeholder")}
                                                        required
                                                    >
                                                    </textarea>

                                                    {errors?.dnc_reason?.message && (
                                                        <ErrorMessage
                                                            text={errors?.dnc_reason?.message}
                                                        />
                                                    )}
                                                </>
                                            }

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" className={'yellow'} loader={loader} btnText={t("couldNotCover.submit")} />
                        <button className="table_delete" type='button' onClick={onClose}>{t("billing.cancel")}</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default DonotCover;